"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.onlyIf = void 0;
var widget_1 = require("../basics/widget");
var onlyIf = function (condition, widget) {
    return condition ? widget : (0, widget_1.nothing)();
};
exports.onlyIf = onlyIf;
